import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const CATEGORIES = [
  { id: 'all', name: 'All Documents', icon: '📚' },
  { id: 'statutes', name: 'Statutes & Laws', icon: '⚖️' },
  { id: 'case_law', name: 'Case Law', icon: '🏛️' },
  { id: 'briefs', name: 'Legal Briefs', icon: '📝' },
  { id: 'contracts', name: 'Contracts', icon: '📄' },
  { id: 'regulations', name: 'Regulations', icon: '📋' }
];

function CategoryFilter({ selectedCategory, onCategoryChange, searchQuery, onSearchChange, documents }) {
  // Count documents per category
  const getCategoryCount = (categoryId) => {
    if (categoryId === 'all') return documents.length;
    return documents.filter(doc => doc.category === categoryId).length;
  };

  return (
    <div className="h-full bg-galaxy-900/60 border-r border-galaxy-800/50 flex flex-col">
      {/* Header */}
      <div className="p-4 border-b border-galaxy-800/50">
        <h1 className="text-lg font-bold text-white mb-2">Knowledge Base</h1>
        <p className="text-xs text-galaxy-400">Legal documents & case law</p>
      </div>

      {/* Search */}
      <div className="p-4">
        <div className="relative">
          <MagnifyingGlassIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-galaxy-500" />
          <input
            type="text"
            placeholder="Search documents..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-9 pr-3 py-2 bg-galaxy-800/50 border border-galaxy-700/50 rounded-lg text-sm text-white placeholder-galaxy-500 focus:outline-none focus:border-galaxy-500"
          />
        </div>
      </div>

      {/* Quick Stats */}
      <div className="mx-4 mb-4 bg-galaxy-800/30 border border-galaxy-700/30 rounded-lg p-3">
        <h3 className="text-xs font-semibold text-galaxy-400 mb-2">Quick Stats</h3>
        <div className="space-y-2">
          <div className="flex justify-between items-center text-xs">
            <span className="text-galaxy-300">Total Documents</span>
            <span className="font-semibold text-white bg-galaxy-700/50 px-2 py-0.5 rounded">
              {documents.length}
            </span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-galaxy-300">Categories</span>
            <span className="font-semibold text-white bg-galaxy-700/50 px-2 py-0.5 rounded">
              {CATEGORIES.length - 1}
            </span>
          </div>
        </div>
      </div>

      {/* Categories */}
      <div className="flex-1 overflow-y-auto px-4">
        <h3 className="text-xs font-semibold text-galaxy-400 mb-2">Categories</h3>
        <div className="space-y-1">
          {CATEGORIES.map(category => {
            const count = getCategoryCount(category.id);
            const isActive = selectedCategory === category.id;

            return (
              <button
                key={category.id}
                onClick={() => onCategoryChange(category.id)}
                className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? 'bg-galaxy-600/40 border-l-2 border-galaxy-500 text-white'
                    : 'text-galaxy-300 hover:bg-galaxy-800/30'
                }`}
              >
                <div className="flex items-center gap-2">
                  <span>{category.icon}</span>
                  <span className={isActive ? 'font-medium' : ''}>{category.name}</span>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  isActive
                    ? 'bg-galaxy-500/30 text-galaxy-200'
                    : 'bg-galaxy-700/30 text-galaxy-400'
                }`}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CategoryFilter;
